/**
 * Created by pajicv on 11/7/18.
 */
import { db } from '../firebase';
import { MANAGER_ROLE, CO_MANAGER_ROLE, WORKER_ROLE } from '../../utils/constants';

export const areThereDocumentsInCycle = cycleId => db.ref('documents')
    .orderByChild('cycle')
    .equalTo(cycleId)
    .once('value')
    .then(snapshot => snapshot.val() || {})
    .then(documents => Object.keys(documents).length > 0);

const deleteWhereCycle = (collection, cycleId) => db.ref(collection)
    .orderByChild('cycle')
    .equalTo(cycleId)
    .once('value')
    .then(snapshot => snapshot.val() || {})
    .then(items => Object.keys(items)
            .reduce((result, itemId) => Object.assign(result, { [`${collection}/${itemId}`]: null }), {})
    );

const reindexCycles = (projectId) => db.ref(`projects/${projectId}`)
    .once('value')
    .then(snapshot => snapshot.val() || {})
    .then(project => project.cycles)
    .then(cycles => {
        const updateCycles = Object
            .keys(cycles || {})
            .sort((cyId1, cyId2) => cycles[cyId1].index - cycles[cyId2].index)
            .map((cyId, i) => ({ [`cycles/${cyId}/index`]: i }))
            .reduce((result, obj) => Object.assign(result, obj), {});
        const updateProject = Object
            .keys(cycles || {})
            .sort((cyId1, cyId2) => cycles[cyId1].index - cycles[cyId2].index)
            .map((cyId, i) => ({ [`projects/${projectId}/cycles/${cyId}/index`]: i }))
            .reduce((result, obj) => Object.assign(result, obj), {});
        const all = Object.assign(updateCycles, updateProject);
        return db.ref().update(all);
    })

export const deleteCycle = (projectId, cycleId) => Promise.all(['documents', 'subTasks', 'tasks'].map(collection => deleteWhereCycle(collection, cycleId)))
    .then((forDelete) => {
    const deleting = forDelete.reduce((collection, result) => Object.assign(result, collection), {});
    const everithingToDelete = Object.assign({
        [`projects/${projectId}/cycles/${cycleId}`]: null,
        [`cycles/${cycleId}`]: null
    }, deleting);
    return db.ref()
                .update(everithingToDelete)
        .then(() => reindexCycles(projectId));
        }
    );

export const toggleActiveTaskInCycle = (cycleId, taskId, type, active) => db.ref().update({
    [`cycles/${cycleId}/tasks/${type}/${taskId}/active`]: active
});



// WEBPACK FOOTER //
// ./src/firebase/db/cycle.js